import React, { useState } from "react";
import "../Styles/AppointmentModal.css";

function AppointmentModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    patientName: "",
    mobileNumber: "",
    problem: "",
    appointmentDateTime: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.patientName || !formData.mobileNumber || !formData.problem || !formData.appointmentDateTime) {
      alert("Please fill in all required fields.");
      return;
    }

    // Construct WhatsApp message
    const message = `New Appointment Request:\n\nPatient Name: ${formData.patientName}\nMobile Number: ${formData.mobileNumber}\nProblem: ${formData.problem}\nAppointment Date & Time: ${formData.appointmentDateTime}`;

    // Encode message for URL
    const encodedMessage = encodeURIComponent(message);

    // WhatsApp number (replace with actual number)
    const whatsappNumber = "1234567890"; // Replace with actual WhatsApp number

    // Construct WhatsApp URL
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    // Open WhatsApp
    window.open(whatsappUrl, '_blank');

    // Reset form and close modal
    setFormData({
      patientName: "",
      mobileNumber: "",
      problem: "",
      appointmentDateTime: ""
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Book an Appointment</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form className="appointment-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="patientName">Patient Name *</label>
            <input
              type="text"
              id="patientName"
              name="patientName"
              value={formData.patientName}
              onChange={handleInputChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="mobileNumber">Mobile Number *</label>
            <input
              type="tel"
              id="mobileNumber"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleInputChange}
              required
              placeholder="Enter your mobile number"
            />
          </div>

          <div className="form-group">
            <label htmlFor="problem">Problem *</label>
            <textarea
              id="problem"
              name="problem"
              value={formData.problem}
              onChange={handleInputChange}
              required
              placeholder="Describe your medical concern"
              rows="4"
            />
          </div>

          <div className="form-group">
            <label htmlFor="appointmentDateTime">Appointment Date & Time *</label>
            <input
              type="datetime-local"
              id="appointmentDateTime"
              name="appointmentDateTime"
              value={formData.appointmentDateTime}
              onChange={handleInputChange}
              required
              min={new Date().toISOString().slice(0, 16)}
            />
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="submit-btn">
              Book Appointment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AppointmentModal;
